import React from 'react'
import { I18n } from 'react-redux-i18n'

import './styles.scss'
import Attachment from '../Attachment'
import { getFormatedDate } from 'utils'
import { getStaticImage } from 'utils/statics'
import AvatarImg from 'components/images/AvatarImg'
import DisplayNameMsg from '../DisplayNameMsg'

const FailedMessage = ({ id, type, message, errorMessage, buttons, date, user, typeTitle, attachments, renderButtons, operatorPicture, operatorName }) => (
  <div id={id} className={`failed-message failed-message--${type}`}>
    <div className='cloud-api-template__operator-info'>
      <figure className='cloud-api-template__operator-picture'>
        <AvatarImg
          src={operatorPicture}
          alt={operatorName}
        />
      </figure>
      <strong className='cloud-api-template__operator-name text-ellipsis'>
        <DisplayNameMsg
          user={user}
          type={type}
          typeTitle={typeTitle}
          operatorName={operatorName || ''}
        />
      </strong>
    </div>

    <div className='failed-message__message'>
      <figure className='failed-message__warning-icon'>
        <img src={getStaticImage('/icons/orange-brand/icon-warning-circle-red.svg')} alt='Warning' />
      </figure>
      <p dangerouslySetInnerHTML={{ __html: message }}></p>
      <span className='failed-message__date'>
        {getFormatedDate({ isoString: date, withTime: true, withYear: true })}
      </span>
    </div>
    <p
      title={errorMessage || ''}
      className='failed-message__error'
    >
      Error: {I18n.t('dashboard_message-not-sent')}.
    </p>
    {buttons?.length ? (
      <div className='failed-message__buttons'>{renderButtons(buttons)}</div>
    ) : null}
    {attachments?.length ? (
      <div className='failed-message__attachments'>
        {attachments?.map((attachment, index) => {
          const { fileId, shortUrl, url, urlLong, mimeType, mimeSubtype, thumb, withVirus } = attachment
          return (
            <Attachment
              key={index}
              id={`attachment-${fileId}`}
              url={urlLong || url}
              mimeType={mimeType}
              mimeSubtype={mimeSubtype}
              shortUrl={url || shortUrl}
              thumb={thumb}
              withVirus={withVirus}
            />
          )
        })}
      </div>
    ) : null}
  </div>
)

export default FailedMessage
